import { useContext } from 'react';
import { AdvertContactsLoadContext, AdvertContactsLoadContextType } from '#advertContacts/contexts';

const useAdvertContactsLoadContext = () => useContext<AdvertContactsLoadContextType>(AdvertContactsLoadContext);

export { useAdvertContactsLoadContext };
